export interface StartTimeIncrementOption {
  value: number;
  label: string;
}

export const START_TIME_INCREMENT_VALUES = [5, 10, 15, 20, 30, 45, 60];

export const getStartTimeIncrementOptions = (
  t: (key: string) => string,
): StartTimeIncrementOption[] =>
  START_TIME_INCREMENT_VALUES.map((value) => ({
    value,
    label: t(`${value} minutes`),
  }));
